import { render, staticRenderFns } from "./MRManageInputs.vue?vue&type=template&id=815d1648"
import script from "./MRManageInputs.vue?vue&type=script&lang=js"
export * from "./MRManageInputs.vue?vue&type=script&lang=js"
import style0 from "./MRManageInputs.vue?vue&type=style&index=0&id=815d1648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports